import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input, FormGroup, Label } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import { fetchSubscriptions, addSubscription, updateSubscription, fetchSubscriptionPackages, createSubscription } from '../../../../../../../Redux/Actions/Admin/ManageSubscriptionActions';
import { fetchSubscriptionTypes, selectSubscriptionType } from '../../../../../../../Redux/Actions/Admin/ManageSubscriptionTypeActions';
import { fetchSubscriptionStatuses, selectSubscriptionStatus } from '../../../../../../../Redux/Actions/Admin/ManageSubscriptionStatusActions';
import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import '../../../ManageSubscriptions/ManageSubscriptions.scss';
import {
    addToPurchase,
    updatePurchase,
    changeView
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';


class Subscription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionInEdit: {},
            value: [],

            view: "Subscription",
            total: "",
            id: 0,
            UserId: "",
            Name: "",
            ActualCost: "",
            SuggestedCost: 0,
            companyName: "",
            preferredMailingName: "",
            firstName: this.props.purchaseAndRenewals.userInfo.firstName || "",
            lastName: this.props.purchaseAndRenewals.userInfo.lastName || "",
            email: this.props.purchaseAndRenewals.userInfo.email || "",
            mailingAddress1: this.props.purchaseAndRenewals.userInfo.address1 || "",
            mailingAddress2: this.props.purchaseAndRenewals.userInfo.address2 || "",
            mailingCity: this.props.purchaseAndRenewals.userInfo.city || "",
            mailingZip: this.props.purchaseAndRenewals.userInfo.zip || "",
            stateId: this.props.purchaseAndRenewals.userInfo.stateId || "",
            state: this.props.purchaseAndRenewals.userInfo.state || "",
            phone: this.props.purchaseAndRenewals.userInfo.phone || "",
            MagazineSubscriptionPackage: {},
            touched: {
                firstName: false,
                lastName: false,
                companyName: false,
                preferredMailingName: false,
                mailingAddress1: false,
                mailingCity: false,
                mailingZip: false,
                phone: false,
                email: false,
            },
        };
    }

    componentDidMount() {
        this.props.fetchSubscriptionPackages();
        this.props.fetchStates();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            ...edited
        });
    };

    handleSubscriptionTypeChange = (event) => {
        if (event.target.value !== null) {
            this.setState({ MagazineSubscriptionPackage: event.target.value });
        }
    }

    handleState = (event) => {
        const value = event.target.value;
        if (value !== null) {
            this.setState({state: value});
        }
    };

    handleStartDateChange = date => {
        this.setState({
            startDate: date
        });
    };

    handleEndDateChange = date => {
        this.setState({
            ExpireDate: date
        });
    };


    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                firstName: true,
                lastName: true,
                companyName: true,
                preferredMailingName: true,
                mailingAddress1: true,
                mailingCity: true,
                mailingZip: true,
                phone: true,
                email: true,
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        return this.state.firstName !== "" &&
            this.state.lastName !== "" &&
            this.state.companyName !== "" &&
            this.state.preferredMailingName !== "" &&
            this.state.mailingAddress1 !== "" &&
            this.state.mailingCity !== "" &&
            this.state.mailingZip !== "" &&
            this.state.email !== "" &&
            this.state.phone !== "";
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            event.preventDefault();
            const newState = Object.assign({}, this.state);
            newState.ActualCost = this.state.MagazineSubscriptionPackage.cost;
            newState.SuggestedCost = Number(this.state.MagazineSubscriptionPackage.cost);

            newState.Name = newState.firstName + " " + newState.lastName;
            this.setState(newState);
            if (this.props.purchaseAndRenewals.editingPurchase.MagazineSubscriptionPackage) {
                this.props.updatePurchase(newState);
            } else {
                this.props.addToPurchase(newState);
            }
            this.props.changeView({ view: "AddItems" })
        } else {
            this.setAllTouchedTrue();
        }
    };

    handlePhoneChange = (event) => {
        var newPhone = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: newPhone
        });
    }


    render() {
        return (
            <form className="user-form" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label htmlFor="subscriptionId">Subscription Type</label>
                        <DropDownList data={this.props.adminSubscription.subscriptionPackages}
                            textField="description"
                            dataItemKey="id"
                            onChange={this.handleSubscriptionTypeChange}
                            value={this.state.MagazineSubscriptionPackage}
                            allowCustom={false}
                            filterable={false}
                            clearButton={false}
                            width={300}
                            required={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="subscriptionStartDate">Subscription Start Date</label>
                        <DatePicker
                            selected={this.state.startDate}
                            onChange={this.handleStartDateChange}
                            minDate={new Date()}
                            maxDate={this.state.ExpireDate}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="subscriptionExpiresDate">Subscription Expiration Date</label>
                        <DatePicker
                            selected={this.state.ExpireDate}
                            onChange={this.handleEndDateChange}
                            minDate={this.state.startDate}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="firstName">First Name</label>
                        <Input
                            type="text"
                            name="firstName"
                            id="firstName"
                            value={this.state.firstName || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.firstName && this.state.firstName === '' ? true: false}
                            onBlur={this.handleBlur('firstName')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="lastName">Last Name</label>
                        <Input
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={this.state.lastName || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.lastName && this.state.lastName === '' ? true: false}
                            onBlur={this.handleBlur('lastName')}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="companyName">Company Name</label>
                        <Input
                            type="text"
                            name="companyName"
                            id="companyName"
                            value={this.state.companyName || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.companyName && this.state.companyName === '' ? true: false}
                            onBlur={this.handleBlur('companyName')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="preferredMailingName">Preferred Mailing Name</label>
                        <Input
                            type="text"
                            name="preferredMailingName"
                            id="preferredMailingName"
                            value={this.state.preferredMailingName || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.preferredMailingName && this.state.preferredMailingName === '' ? true: false}
                            onBlur={this.handleBlur('preferredMailingName')}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="mailingAddress1">Address 1</label>
                        <Input
                            type="text"
                            name="mailingAddress1"
                            id="mailingAddress1"
                            value={this.state.mailingAddress1 || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.mailingAddress1 && this.state.mailingAddress1 === '' ? true: false}
                            onBlur={this.handleBlur('mailingAddress1')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="mailingAddress2">Address 2</label>
                        <Input
                            type="text"
                            name="mailingAddress2"
                            id="mailingAddress2"
                            value={this.state.mailingAddress2 || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <label htmlFor="mailingCity">City</label>
                        <Input
                            type="text"
                            name="mailingCity"
                            id="mailingCity"
                            value={this.state.mailingCity || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.mailingCity && this.state.mailingCity === '' ? true: false}
                            onBlur={this.handleBlur('mailingCity')}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="State" className="">State </label>
                        <DropDownList data={this.props.common.states}
                            dataItemKey="id"
                            textField="name"
                            onChange={this.handleState}
                            value={this.state.state}
                            allowCustom={false}
                            filterable={false}
                            clearButton={false}
                            width={300}
                            required={true}
                            name="State"
                            id="State"
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="mailingZip">Zip</label>
                        <Input
                            type="text"
                            name="mailingZip"
                            id="mailingZip"
                            pattern="(\d{5}([\-]\d{4})?)"
                            placeholder="12345"
                            value={this.state.mailingZip || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.mailingZip && this.state.mailingZip === '' ? true: false}
                            onBlur={this.handleBlur('mailingZip')}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="email">Email</label>
                        <Input
                            type="text"
                            name="email"
                            id="email"
                            value={this.state.email || ''}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.email && this.state.email === '' ? true: false}
                            onBlur={this.handleBlur('email')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="phone">Phone</label>
                        <Input
                            type="text"
                            name="phone"
                            id="phone"
                            value={this.state.phone || ''}
                            onChange={this.handlePhoneChange}
                            pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                            title="Phone Number (Format: (123) 456-7890)"
                            placeholder="(123) 456-7890"
                            invalid={this.state.touched.phone && this.state.phone === '' ? true: false}
                            onBlur={this.handleBlur('phone')}
                        />
                    </div>
                </div>
                <div className="footer">
                    <div className="form-group">
                        <button type="submit" className="admin-k-button">
                            <i className="fas fa-save"></i>
                            <span>SAVE</span>
                        </button>
                        <button className="admin-k-button" onClick={ () => this.props.changeView({ view: "AddItems" })}>
                            <i className="fas fa-times"></i>
                            <span>CANCEL</span>
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
        subscription: state.adminSubscription,
        common: state.common,
        subscriptionType: state.subscriptionType,
        subscriptionStatus: state.subscriptionStatus,
        adminSubscription: state.adminSubscription,
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    fetchStates,
    fetchSubscriptionStatuses,
    selectSubscriptionStatus,
    fetchSubscriptionTypes,
    selectSubscriptionType,
    fetchSubscriptionPackages,
    fetchSubscriptions,
    addSubscription,
    updateSubscription,
    createSubscription,
    addToPurchase,
    updatePurchase,
    changeView
})(Subscription);
